
import { SortOrder } from "element-ui/types/table";
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { ReceptionDetailSearchCondition, } from "../../../domain/workflow/search";
import { ReceptionDetailListDispInfo } from "../../../domain/workflow/list";
import { WorkflowStatusName, DocumentCreateButtonInfo, } from "../../../domain/workflow/items";
import { WorkflowStatusKinds, } from "../../../domain/workflow/kinds";
import { default as WorkflowListBaseMixin } from "./WorkflowListBaseMixin.vue";

@Component
export default class ManagerHistoryListViewMixin extends Mixins(WorkflowListBaseMixin) {
  @Prop()
  defaultDisplaySetting: ReceptionDetailListDispInfo;

  @Prop()
  defaultTableSortType: string;

  @Prop()
  defaultTableOrderType: SortOrder;

  @Prop()
  defaultListTableSortType: string;

  @Prop()
  defaultListTableOrderType: SortOrder;

  @Emit()
  changeButtonInfo(buttons: DocumentCreateButtonInfo[]): void {}

  @Emit()
  changeNewReceptionButtonEnable(isEnable: boolean): void {}

  @Emit()
  changeDocumentListButtonEnable(isEnable: boolean): void {}

  data(): any {
    return {
      displaySetting: null as ReceptionDetailListDispInfo,
      searchCondition: null,
    };
  }
  displaySetting: ReceptionDetailListDispInfo;
  searchCondition: ReceptionDetailSearchCondition;

  async created() {
    if (this.defaultDisplaySetting) {
      // 起動時やカード・リスト切り替え時、displaySettingがnullのため親で取得した設定で先に描画
      this.displaySetting = this.defaultDisplaySetting;
    }
    await this.getDispSetting();
  }

  get searchConditionSummary(): string {
    return this.searchCondition ? this.searchCondition.getSummary(this.generalFlag1LabelName) : "";
  }

  get finishStatus(): WorkflowStatusName {
    return this.displaySetting ? this.displaySetting.getWorkflowStatuses(WorkflowStatusKinds.Finished)[0] : null;
  }

  // 検索条件の状態リスト
  get workflowStatusList(): WorkflowStatusName[] {
    if (!this.displaySetting) { return []; }
    return this.displaySetting.workflowStatuses;
  }

  // 表示設定取得
  async getDispSetting(): Promise<void> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.getReceptionDetailListInitSetting();
      this.isLoading = false;

      this.$logger.debug("displaySetting is set.");
      this.displaySetting = result;
      this.changeButtonInfo(this.displaySetting ? this.displaySetting.documentCreateButtons : []);
      this.changeNewReceptionButtonEnable(this.displaySetting ? this.displaySetting.isNewReceptionButtonEnable : true);
      this.changeDocumentListButtonEnable(this.displaySetting ? this.displaySetting.isDocumentListButtonEnable : true);
      this.changeManagerHistorySearchEnable(this.displaySetting ? this.displaySetting.isManagerHistorySearchEnable : false);

    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "表示設定の取得に失敗しました。", e);
    }
  }
}
